// extracted by mini-css-extract-plugin
export default {"actionCards":"action-cards_actionCards__-06Ay"};